import { ChapterConfig } from "../../../ChapterConfig";
import { OutlineBox } from "../../../../Comps/OutlineBox/OutlineBox";
import { ChapterNav, ChapterNavItem } from "../../ChapterNav/ChapterNav";
import { ChapterRoutes } from "../../ChapterNav/ChapterRoutes";
import { ClearHelpers } from "../../../Helpers/ClearHelpers/ClearHelpers";
import { useState } from "react";
import { DotNav } from "../../../../Comps/DotNav/DotNav";
import '../HarmonicCycles.scss'
import { CycleOfFifthsPair } from "./CycleOfFifthsPair";
import { CycleOfFifthsMap } from "./CycleOfFifthsMap";

export function CycleOfFifths(props:ChapterConfig){
    const subPaths:ChapterNavItem[] = [
        {title:'Lesson', path:'lesson', element:<ClearHelpers><Lesson/></ClearHelpers>}
    ]
    return  <div className={'hex-map-notes-chapter'}>
                <h1>The Circle of Fifths in the HexMap</h1>
                <ChapterNav path={props.path} subPaths={subPaths}/>
                <ChapterRoutes chapterNavs={subPaths}/>
            </div>
}

export function Lesson(){
    const width:number = 900
    const [screenIndex, setScreenIndex] = useState(0)

    const onNavClick = (navIndex:number) => {
        setScreenIndex(navIndex)
    }
    const getHexMaps = () => {return [
        <CycleOfFifthsMap/>,
        <CycleOfFifthsPair/>
    ]}
    const hexMaps = getHexMaps()

    return(
        <OutlineBox title={'The Circle of Fifths: A Diagonal Column'} width={width}>
            <div className={'harmonic-cycle'}>
                <div className={'harmonic-cycle-page-container'}>
                    {hexMaps[screenIndex]}
                </div>
            </div>
            <DotNav length={hexMaps.length} selectedIndex={screenIndex} onClick={onNavClick}/>
        </OutlineBox>
    )
}
